
<div class="row">
    <div class="col-12">
        <app-asset-result [assets]="assets" [totalItems]="totalItems" [renderStyle]="renderStyle"></app-asset-result>
    </div>
</div>
